import React from 'react';

import logo from '../gm_logo.png';

const Header = ({ hotelColor, hotelLogo }) => {
  const color = hotelColor && hotelColor !== "" ? hotelColor : "#232731";
  const display = hotelLogo && hotelLogo !== "" ? 'inline' : 'none';
  return (
    <header className="container">
      <div className="header-div" style={ {"background": color}} >
      <div className="row">
        <div className="col-md-6 col-md-offset-3">
          <img className="header_img" style={ { "display": display } } src={hotelLogo && hotelLogo !== "" ? hotelLogo : logo} height='50' />
        </div>
        <div className="col-md-4">
        </div>
      </div>
      </div>

    </header>
  )
};

export default Header;
